import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeftLong,
  faArrowRightLong,
} from "@fortawesome/free-solid-svg-icons";
import styles from "../DetailsTab.module.css";

/**
 * RailHeader — small strip above the right-rail panels that shows the last
 * call timestamp on the left and the prev/next patient navigation on the
 * right. Behavior of the arrows is unchanged from the legacy header tab-bar
 * navigation; we just relocate the visual.
 *
 * Layout-pass scope (TH-A1): renders the strip in its new position. TH-B4
 * polishes the visual to match Figma exactly.
 */
const RailHeader = ({
  lastCalled,
  currentIndex,
  totalPatients,
  canGoBack,
  canGoForward,
  onBack,
  onForward,
}) => {
  return (
    <div className={styles.railHeader}>
      <div className={styles.railHeaderMeta}>
        Last called : <strong>{lastCalled || "--"}</strong>
      </div>
      <div className={styles.railNav}>
        <button
          type="button"
          className={styles.railNavBtn}
          onClick={canGoBack ? onBack : undefined}
          disabled={!canGoBack}
          aria-label="Previous patient"
        >
          <FontAwesomeIcon icon={faArrowLeftLong} />
        </button>
        <span className={styles.railNavCounter}>
          Patient {currentIndex} / {totalPatients}
        </span>
        <button
          type="button"
          className={styles.railNavBtn}
          onClick={canGoForward ? onForward : undefined}
          disabled={!canGoForward}
          aria-label="Next patient"
        >
          <FontAwesomeIcon icon={faArrowRightLong} />
        </button>
      </div>
    </div>
  );
};

export default RailHeader;
